export const shopItemListFilteringEnum = Object.freeze({
    ALL: "all",
    ONLY_AVAILABLE: "available",
    ONLY_UNAVAILABLE: "unavailable"
});




